import React, { Component } from "react";
import Select from "react-select";
import {
  Button,
  CardBody,
  Form,
  InputGroup,
  InputGroupAddon,
  InputGroupText,
  Row,
  Col,
  Input,
} from "reactstrap";

export default class ModalFormNext extends Component {
  render() {
    //   {console.log(this.props.selectedOption)}
    return (
      <CardBody className="m-3">
        <Form>
          <Row>
            <Col lg={12}><h2 className="loginText">Create New Account</h2></Col>
          </Row>
          <Row>
            <Col><p className="Practitioner-text">Practitioners</p></Col>
          </Row>
          
          <Row>
            <Col lg={10}>
            <InputGroup className="mb-2 mt-5 mywrap">
            <InputGroupAddon addonType="prepend">
              <InputGroupText
                style={{ backgroundColor: "#F1F5FF", border: "#F1F5FF" }}
              >
                <i className="bi bi-bag-fill inputIconLogin"></i>
              </InputGroupText>
            </InputGroupAddon>
            <Select
              className="service-dropdown loginOTPStyle"
              name="selectedOption"
              isMulti="true"
              value={this.props.selectedOption}
              onChange={this.props.handleallServicesChange}
              options={this.props.options}
              placeholder="Select Services"
              required
              style={{ width: "100%" }}
            />
          </InputGroup>
            </Col>
          </Row>

        <Row>
          <Col lg={10}>
          <InputGroup className="mb-2">
            <InputGroupAddon addonType="prepend">
              <InputGroupText
                style={{ backgroundColor: "#F1F5FF", border: "#F1F5FF" }}
              >
                <i className="bi bi-telephone-fill inputIconLogin"></i>
              </InputGroupText>
            </InputGroupAddon>
            <Input
              type="number"
              name="vendorMobileNumber"
              id="vendorMobileNumber"
              placeholder="Mobile Number"
              onChange={this.props.onRegistrationMobileChangeHandler}
              value={this.props.vendorMobileNumber}
              pattern="[6-9]{1}[0-9]{9}"
              maxLength={10}
              minLength={10}
              autocomplete="off"
              className="loginOTPStyle"
              style={{ backgroundColor: "#F1F5FF", border: "#F1F5FF" }}
              required
            />
          </InputGroup>
          </Col>
        </Row>

          {this.props.vendorVerifyOtpSection === 1 &&
          this.props.vendorMobileNumber.length === 10 && (
            <Row>
              <Col lg={10}>
              <InputGroup className="mt-1">
              <InputGroup className="mb-1">
                <InputGroupAddon addonType="prepend">
                  <InputGroupText
                    style={{ backgroundColor: "#F1F5FF", border: "#F1F5FF" }}
                  >
                    <i className="bi bi-chat-left-text-fill inputIconLogin"></i>
                  </InputGroupText>
                </InputGroupAddon>
                <Input
                  type="number"
                  name="vendorVerifyOtp"
                  id="vendorVerifyOtp"
                  placeholder="Enter OTP"
                  className="loginOTPStyle"
                  maxLength={6}
                  minLength={6}
                  onChange={this.props.onOtpChangeHandler}
                  value={this.props.vendorVerifyOtp}
                  autocomplete="off"
                  style={{ backgroundColor: "#F1F5FF", border: "#F1F5FF" }}
                  required
                />
              </InputGroup>
            </InputGroup>
              </Col>
            </Row>
          )}

          {this.props.vendorMobileNumber.length === 10 ? (
            <span
              color="info"
              className="otpBtn"
              onClick={() => this.props.sendRegistrationOtpHandler()}
            >
              {this.props.registrationOtpButtonText}
            </span>
          ) : (
            ""
          )}

          <Row className="text-center mt-5">
            {/* <Col md="12">
            <span> Not Registered ?</span>
            <span
              className="pl-2 text-primary"
              onClick={(e) => this.props.changeStatusHandler("2")}
              style={{ cursor: "pointer" }}
            >
              Sign Up
            </span>
          </Col> */}
            <Col xs="12" className="mb-3" lg={10}>
              <Button
                color="warning"
                className="mt-3 colorOfBtn"
                id="vendorPostform"
                onClick={(e)=>this.props.vendorRegistrationHandler(e)}
              >
                SIGN UP
              </Button>
            </Col>

            <Col
              xs="12"
              lg={10}
              // style={{ display: "flex", justifyContent: "space-between" }}
            >
              <p
                className="createAccount paragraph-style mb-0"
                onClick={(e) => this.props.changeStatusHandler("0")}
              >
                I have an account
              </p>
            </Col>
          </Row>
        </Form>
        {/* <Row className="text-center">
        <Col xs="12">
          <div>or</div>
          <div onClick={(e) => this.props.changeStatusHandler("1")}>
            <span>
              Login with OTP
            </span>
          </div>
        </Col>
      </Row> */}
      </CardBody>
    );
  }
}
